import DOMPurify from "dompurify";

const CONFIG = {
  ALLOWED_TAGS: ["p", "br", "strong", "b", "em", "i", "u", "s", "a", "span", "ul", "ol", "li"],
  ALLOWED_ATTR: ["href", "target", "rel", "style", "class"],
  // Only allow color style
  ALLOWED_STYLE: ["color"],
};

// Additional attribute hook: force safe link attributes.
if (typeof window !== "undefined") {
  DOMPurify.addHook("afterSanitizeAttributes", (node) => {
    if (node.tagName === "A" && node.hasAttribute("href")) {
      node.setAttribute("target", "_blank");
      node.setAttribute("rel", "noopener noreferrer");
    }
    // Strip style attributes except color:*
    if (node.hasAttribute("style")) {
      const style = node.getAttribute("style") || "";
      const parts = style.split(";").map(s => s.trim()).filter(s => /^color\s*:/i.test(s));
      if (parts.length) node.setAttribute("style", parts.join("; "));
      else node.removeAttribute("style");
    }
  });
}

const RICH_CONFIG = {
  ALLOWED_TAGS: [...CONFIG.ALLOWED_TAGS, "h2", "h3", "img", "mark"],
  ALLOWED_ATTR: [...CONFIG.ALLOWED_ATTR, "src", "alt"],
  ALLOWED_URI_REGEXP: /^(?:https?:|mailto:|\/)/i,
};

export function sanitizeRich(html) {
  if (!html) return "";
  return DOMPurify.sanitize(html, RICH_CONFIG);
}

export function sanitize(html) {
  if (!html) return "";
  return DOMPurify.sanitize(html, CONFIG);
}
